export default {
  'Pracuji...': 'Loading...',
  "Pravidlá forecastu": "Forecast rules",
  "Forecast komunikace": "Forecast communication",
  "Nastavení pravidel": "Setting rules",
  "Import forecastu": "Import of forecast",
  "Kmenová data OPM pro forecast": "PDT master data for forecast",
  "Forecast na kalendářní měsíc": "Forecast for the calendar month",
  "Pravidla pro předpoklady na celý měsíc": "RULES ONLY FOR MONTHLY FORECASTS",
  "Nové pravidlo": "New rule",
  "Editovat pravidlo": "Edit rule",
  "Uložit pravidlo": "Save rule",
  "Smazat pravidlo": "Delete rule",
  "Import EAN/EIC": "Import EAN/EIC",
  Komodita: "Commodity",
  Elektřina: "power",
  Plyn: "natural gas",
  "Status OPM": "Status of Point of Delivery / Transfer",
  "Platnost pravidla od": "Validity of rule From",
  "Platnost pravidla do": "Validity of rule To",
  "Typ měřidla": "Type of meter",
  "Spotřeba od": "Consumption from",
  "MWh/rok": "MWh/rok",
  "Spotřeba do": "Consumption to",
  "Alert poslat na e-mail": "Alert send to e-mail",
  "Forecast poslat na e-mail": "Forecast send to e-mail",
  "Zobrazit seznam OPM v novém okně":
    "Display list of delivery points in new window",
  "Všechny OPM": "All PDTˈs",
  "Active OPMs": "Active PDTˈs",
  "Inactive OPMs": "Inactive PDTˈs",
  "Aktivne OPM": "Active PDTˈs",
  "Neaktivne OPM": "Inactive PDTˈs",
  "Zrusene OPM": "Cancelled OPM",
  "Aktualizace měsíčního forecastu": "Monthly forecast update",
  Perióda: "Period",
  "První den periody": "First day of period",
  "Blokovat pravidlo - počet dnů na začátku měsíce":
    "Block rule - the number of first days of the month",
  "1 deň": "1 day",
  "7 dní": "7 days",
  pondělí: "monday",
  úterý: "tuesday",
  středa: "wednesday",
  čtvrtek: "thursday",
  pátek: "friday",
  sobota: "saturday",
  neděle: "sunday",
  "Pravidlo bylo uloženo.": "Rule has been saved.",
  "Pravidlo bylo smazáno.": "Rule has been deleted.",
  "Měli by existovat jen 2 pravidla pro stejnou komoditu. Chcete pokračovat?":"Only 2 rules should exist for the same commodity. Do you really want to proceed?",
  "Pole \"Alert poslat na e-mail\" musí být vyplněno": "Field 'Alert send to e-mail' is required",
  "Pole \"Předpoklad poslat na e-mail\" musí být vyplněno": "Field 'Forcasts send to e-mail' is required",
  "Předpoklad spotřeby": "Forecast",
  "Seznam požadovaných OPM": "List forecasts",
  Den: "Day",
  "Den/Název": "Day/Name",
  "Den/Typ": "Day/Type",
  "Měsíčni předpoklad (MWh)": "Monthly forecast (MWh)",
  "Týdenní aktualizace (MWh)": "Weekly update (MWh)",
  "Rozdíl (MWh)": "Difference (MWh)",
  Poznámka: "Note",
  "Pokud je v označené buňce vyplněn údaj nula „0“, tak to znamená předpokládanou spotřebu 0 MWh.":
    "If selected cell contains zero „0“ it means 0 MWh consumption assumed.",
  "Bez změny": "No changes",
  Uložiť: "Save",
  "Uložit": "Save",
  "Uložené": "Saved",
  Spolu: "Total",
  "Stáhnout vzorový soubor .xls pro": "Download template .xls for",
  "pracovní den": "working day",
  "víkend": "weekend",
  "svátek": "national holiday",
  "Automatické odhlášení za": "Auto logout for",
  "Hromadny import?": "Data Import",
  "den pracovního klidu": "national holiday",
  'Pravidla forecastu': 'Forecast rules',
  "Seznam OPM":"OPM List",
  "Název":"Name",
  "Město":"City",
  "Typ měření":"Type of measurement",
  "Odhad roční spotřeby":"Estimated yearly consumption",
  "Import neúspěšný. Buňka :replacment: není v požadovaném tvaru.": "Import failed. Cell :replacment: is not in the desired shape.",
  "Data v souboru se neshodují s daty, pro které nahráváte forecast (např. různý počet dní, nesprávný měsíc apod.)": "The dates in the file do not match the dates for which you are forecasting (e.g., different number of days, incorrect month, etc.)",
  "Soubor obsahuje údaje pro datum :replacment:, který nepatří do zvoleného období.": "The file contains data for the date :replacment: which does not belong to the selected period.",
  "Pole \"Komodita\" musí být vyplněno": "Field 'Commodity' is required",
  "Pole \"Seznam požadovaných OPM\" musí být vyplněno": "Field 'List forecasts' is required",
  "Zkopírovat měsíční předpoklad": "Copy monthly assumption",
  "Nastavení pravidel pro odhad spotřeby vždy na celý kalendářní měsíc.":  "Setting the rules for estimating consumption always for the whole calendar month.",
  "Nastavení pravidel pro upřesňování měsíčního odhadu spotřeby.":  "Setting rules for refining the monthly consumption estimate.",
  "Perioda upřesňování odhadu": "Period of refinement of the estimate",
  "import-ean-eic": "Box for entering the codes of specific delivery points. When you fill in this box, some other boxes will not work (",
  "import-ean-eic-items": "Commodity, Status of point of delivery / transfer, Type of meter, Consumption from, Consumption to boxes",
  "state-opm": "Active PDTˈs are PDTˈs where the meter is not dismantled or the supply is not interrupted.",
  "rule-validity-from": "The date you want this rule to be effective From.",
  "rule-validity-to": "The date by which you want this rule to be effective.",
  "consuption-from": "Volume of annual energy consumption at the point of delivery in MWh/year. The rule will only apply to those consumption points that have a planned/estimated annual energy consumption equal to or higher than the value in the box.",
  "consuption-to": "Volume of annual energy consumption at the point of delivery in MWh/year. The rule will only apply to those consumption points that have a planned/estimated annual energy consumption equal to or less than the value in the box.",
  "alert-email": "E-mail address/adresses of the person/persons at the energy supplier (if the customer does not send the supplier an estimate of energy consumption for the following period by the deadline, the system will send a notification about this to the supplier's addresses). The separator between email addresses is a comma or a semicolon.",
  "forecast-email": "E-mail address/addresses of the person/persons at the energy supplier to which the system will send the energy consumption estimation as uploaded by the customer to the system. The separator between email addresses is a comma or a semicolon.",
  "show-opms-in-new-window": "View the PDT list for this month's consumption estimate (in a new window)",
  "import-ean-eic-weekly": "According to this rule, the customer will specify the monthly consumption estimate once a week. In the box, you can enter only the codes of the delivery points for which the superior rule for estimating consumption for the entire calendar month applies.",
  "period-weekly": "The period of regular refinement of the monthly consumption estimate. The predefined period is 1x per week.",
  "period-first-day-weekly": "For practical reasons, the beginning of the period is set to Thursday - so that the supplier has information for the period of the next 7 days, which starts on Thursday, available on Wednesday at the latest.",
  "block-rule-weekly": "The possibility to block the rule for refining the monthly consumption estimate for a few days (at the beginning of each month) so that, due to the calendar, a situation does not arise where the customer will be obliged to report the monthly consumption estimation for the entire calendar month, and the system will send him a notification to report the very next day specification.",
  "show-opms-in-new-window-weekly": "View PDT's list for this monthly consumption estimate refinement (in a new window)",
  "inactivity-logout": "You have been automatically logged out of the system due to inactivity.",
  "Kmenová data OPM pro odhad spotřeby" : "PDT master data for forecast",
  "Kmenová data export": "Master data export",
  "Kmenová data import": "Master data import",

  "Měření": "Measured data",
  "Dátum od": "Date from",
  "Dátum do": "Date to",
  "Elektrická energie": "Electricity",
  "Zemní plyn": "Gas",
  "Druh OPM": "Type",
  "Výroba + Spotřeba": "Production + Consumption",
  "Výroba": "Production",
  "Spotřeba": "Consumption",
  "Typ dát": "Type of data",
  "Korigované + Normalizované": "Corrected profiles + Normalized Diagrams",
  "Normalizované": "Normalized Diagrams",
  "Korigované": "Corrected profiles",
  "1 hodina": "1 hour",
  "15 minut": "15 minutes",
  "Poskytovatel měřených dat": "Measured data provider",
  "-- Všichni --": "-- All --",
  "Primární dodavatel": "Primary supplier",
  "Jazyk": "Language",
  "Česky": "Česky",
  "English": "English",
  "Zadejte seznam odběrných míst": "Codes of off-take points",
  "Export": "Export",
  "Odběrná místa": "Master data",
  "Odhlásit": "Logout",
  "Aktuální počet úkolů:": "Current number of tasks:"
};



// WEBPACK FOOTER //
// ./src/Translate/en.js